import { MarkdownContent } from "@/components/ui/markdown-content";
import { t } from "@/lib/typography";

// "What you just learned" — the consolidation prose revealed on completion.
export function Consolidation({ md }: { md: string }) {
  return (
    <div className="space-y-2">
      <p className={t.label}>What you just learned</p>
      <MarkdownContent>{md}</MarkdownContent>
    </div>
  );
}
